module.exports = __webpack_public_path__ + "img/user.891baa79.png";